import {useAxiosClient} from "~/use/axios/client";
import {GmModelLibraryModelsReallocatedAreaModel, ReallocatedAreaApi} from "~/gen/openapi/sblService";
import {keepPreviousData, useQuery, UseQueryOptions} from "@tanstack/vue-query";
import {MS_HOUR} from "~/constants/time";
import {queryClient} from "~/plugins/vue-query";

export const useReallocatedAreasService = () => {
    const { axiosClient } = useAxiosClient()
    const reallocatedAreaApi = new ReallocatedAreaApi(undefined, '', axiosClient.value)

    const reallocatedAreasQueryOptions: UseQueryOptions<GmModelLibraryModelsReallocatedAreaModel[]> = {
        queryKey: ['reallocatedAreaGetReallocatedAreas'],
        queryFn: async () => {
            return (await reallocatedAreaApi.reallocatedAreaGetReallocatedAreas())?.data
        },
        staleTime: MS_HOUR,
        placeholderData: keepPreviousData,
        networkMode: 'offlineFirst',
        gcTime: Infinity,
    }

    const reallocatedAreasQuery = () => useQuery(reallocatedAreasQueryOptions)

    const reallocatedAreas = computed(() => (queryClient.getQueryData(reallocatedAreasQueryOptions.queryKey) || []) as GmModelLibraryModelsReallocatedAreaModel[])

    return {
        reallocatedAreasQueryOptions,
        reallocatedAreasQuery,
        reallocatedAreas,
    }
}